import PipeCard from "../../../pipe-common/PipeCard";
import React from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {formatToExponential} from "../../../../helpers/NumberHelper";

const defaultIndicators = {
    pressure: "---"
};

export default function PfeifferVacuumTpg361ReadBack({pipe, data}) {
    const indicators = data
        ? Object.assign(defaultIndicators, {
            pressure: data["pressure"] || defaultIndicators.pressure
        }) : defaultIndicators;

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container direction={"row"} justify={"center"} alignItems={"center"} spacing={2}>
                    <Grid item>
                        <TextField
                            id="pressure"
                            label="Pressure"
                            value={formatToExponential(indicators.pressure)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                </Grid>
            }
        />
    );
}